// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"375":"cec22f75","453":"f1417e94"}[chunkId] + ".chunk.js";
};